import React, {FC} from 'react';
import {Button} from 'antd';
import {observer} from 'mobx-react-lite';
import classNames from 'classnames';
import {useRootStore} from '@joyrideautos/ui-models/src/stores/rootStore/useRootStore';
import {SoundFilled, SoundOutlined} from '@ant-design/icons';
import {RootStoreType} from '@models/stores/types';

interface SoundBtnProps {
    className?: string;
}

export const SoundBtn: FC<SoundBtnProps> = observer(({className}) => {
    const rootStore = useRootStore<RootStoreType>();
    const {soundStore} = rootStore;
    const {isSoundMuted, toggleSound, canBrowserPlaySound} = soundStore;

    if (!canBrowserPlaySound) {
        return null;
    }

    return (
        <Button size="large" className={classNames(className, {active: !isSoundMuted})} onClick={toggleSound}>
            {!isSoundMuted ? <SoundFilled></SoundFilled> : <SoundOutlined></SoundOutlined>}
        </Button>
    );
});
